import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  Animated,
  Dimensions,
  StyleSheet,
  Image,
} from 'react-native';
import ConfettiCannon from 'react-native-confetti-cannon';
import images from '../config/Images';

export const Confetti = () => {
  const [showConfetti, setShowConfetti] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(70)).current; // starting position of image
  const textAnimStarted = useRef(false);
  const windowWidth = Dimensions.get('window').width;
  const windowHeight = Dimensions.get('window').height;
  const fullText = 'Your cash flow is finally exactly where it needs to be!';

  useEffect(() => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 2000,
        useNativeDriver: true,
      }),
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 2000,
        useNativeDriver: true,
      }),
    ]).start(() => {
      if (!textAnimStarted.current) {
        textAnimStarted.current = true;

        let index = 0;
        const intervalId = setInterval(() => {
          setDisplayText(fullText.slice(0, index + 1));
          index++;
          if (index === fullText.length) {
            clearInterval(intervalId);
            setShowConfetti(true);
          }
        }, 50);
      }
    });
  }, [fadeAnim, slideAnim]);

  const imageTranslateY = slideAnim.interpolate({
    inputRange: [0, 70], //starting and ending positions of image
    outputRange: [0, 70],
  });

  return (
    <View
      style={{
        width: windowWidth / 3,
        height: windowHeight,
        position: 'relative',
      }}
    >
      <Animated.View
        style={{
          position: 'absolute',
          top: 0,
          left: 20,
          opacity: fadeAnim,
          transform: [{ translateY: imageTranslateY }],
        }}
      >
        <Image source={images.cashplanit} style={styles.image} />
      </Animated.View>

      <View style={{ position: 'absolute', top: 270, left: 60 }}>
        <Text style={styles.text}>{displayText}</Text>
      </View>

      {showConfetti && (
        <ConfettiCannon
          count={300}
          origin={{ x: windowWidth / 6, y: 400 }}
          fadeOut={true}
          explosionSpeed={1000}
          fallSpeed={1000}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  text: {
    fontSize: 22,
    fontWeight: '400',
    color: '#FFFFFF',
    fontFamily: 'Caveat_400Regular',
    textAlign: 'left',
  },
  image: {
    width: 270,
    height: 250,
  },
});
